var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "workflow-form" } }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "input title-input" },
        [
          _c("div", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t("task.title"))),
          ]),
          _vm._v(" "),
          _c("a-input", {
            staticClass: "classic-new-input",
            attrs: { placeholder: _vm.$t("task.taskNumber") },
            model: {
              value: _vm.form.title,
              callback: function ($$v) {
                _vm.$set(_vm.form, "title", $$v)
              },
              expression: "form.title",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "input title-input" },
        [
          _c("div", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t("message.description"))),
          ]),
          _vm._v(" "),
          _c("quill-editor", {
            staticClass: "quill-editor",
            attrs: {
              options: _vm.editorOption,
              placeholder: _vm.$t("task.workflowCreateDesc"),
            },
            model: {
              value: _vm.form.description,
              callback: function ($$v) {
                _vm.$set(_vm.form, "description", $$v)
              },
              expression: "form.description",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "input title-input" },
        [
          _c("div", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t("task.stagesAndStatuses"))),
          ]),
          _vm._v(" "),
          _c(
            "draggable",
            {
              attrs: {
                options: _vm.dragOptions,
                draggable: ".drag-row",
                group: { name: "pipeline", pull: "clone", put: false },
              },
              model: {
                value: _vm.form.pipelines,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "pipelines", $$v)
                },
                expression: "form.pipelines",
              },
            },
            [
              _c(
                "transition-group",
                { staticClass: "drag-rows" },
                _vm._l(_vm.form.pipelines, function (pipeline, index) {
                  return _c(
                    "div",
                    {
                      key: "p_" + index,
                      staticClass: "drag-row",
                      style: { "--row-color": "" + pipeline.color },
                      on: {
                        dblclick: function ($event) {
                          return _vm.editStage(pipeline)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "pipeline-content" }, [
                        _c("div", { staticClass: "pipeline-picker" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: pipeline.color,
                                expression: "pipeline.color",
                              },
                            ],
                            staticStyle: { opacity: "0" },
                            attrs: { type: "color" },
                            domProps: { value: pipeline.color },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(pipeline, "color", $event.target.value)
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "pipeline-name",
                            class: { editable: pipeline.isEditing },
                            attrs: { contenteditable: "true" },
                            on: {
                              blur: function (e) {
                                return (pipeline.name = e.target.innerText)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(pipeline.name) +
                                "\n                            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        pipeline.isEditing
                          ? _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: pipeline.type,
                                    expression: "pipeline.type",
                                  },
                                ],
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      pipeline,
                                      "type",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              [
                                _c("option", { attrs: { value: "todo" } }, [
                                  _vm._v("Todo"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "option",
                                  { attrs: { value: "in-progress" } },
                                  [_vm._v("In Progress")]
                                ),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "approval" } }, [
                                  _vm._v("Approval"),
                                ]),
                                _vm._v(" "),
                                _vm.form.pipelines.filter(function (p) {
                                  return p.type === "completed"
                                }).length < 1 || pipeline.type === "completed"
                                  ? _c(
                                      "option",
                                      { attrs: { value: "completed" } },
                                      [
                                        _vm._v(
                                          "\n                                    Completed\n                                "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "last-action" }, [
                        _c("div", { staticClass: "pipeline-type" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.formatType(pipeline.type))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pipeline-actions" }, [
                          !pipeline.isEditing
                            ? _c(
                                "div",
                                {
                                  staticClass: "material-icons edit-button",
                                  on: {
                                    click: function ($event) {
                                      return _vm.editStage(pipeline)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                    edit\n                                "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          pipeline.isEditing
                            ? _c(
                                "div",
                                {
                                  staticClass: "material-icons save-button",
                                  on: {
                                    click: function ($event) {
                                      return _vm.saveStage(pipeline)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                    save\n                                "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.canDelete(pipeline.type)
                            ? _c(
                                "div",
                                {
                                  staticClass: "material-icons delete-button",
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteStage(pipeline)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                    delete\n                                "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "SupsisButton",
            {
              staticStyle: { "margin-top": "10px" },
              on: {
                click: function ($event) {
                  return _vm.$feature.beforeCreateTaskColumn(
                    _vm.createStage,
                    _vm.form.pipelines.length
                  )
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("task.createStage")))]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }